import React from 'react';

export default class AppErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Application rendering error:', error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <main
        role="alert"
        style={{
          minHeight: '100dvh',
          display: 'grid',
          placeItems: 'center',
          padding: 24,
          background: '#f8fafc',
          color: '#0f172a',
        }}
      >
        <section style={{ maxWidth: 460, textAlign: 'center' }}>
          <h1>Something went wrong</h1>
          <p style={{ color: '#475569', lineHeight: 1.6 }}>
            This page could not be displayed. You can retry or reload the application.
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: 12, flexWrap: 'wrap' }}>
            <button type="button" onClick={this.handleRetry}>Try again</button>
            <button type="button" onClick={this.handleReload}>Reload application</button>
          </div>
        </section>
      </main>
    );
  }
}